import React from 'react';

export interface ListPageHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
}

export const ListPageHeader: React.FC<ListPageHeaderProps> = ({
  title,
  subtitle,
  actions,
}) => (
  <header className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between border-b border-border pb-4">
    <div className="min-w-0">
      <h1 className="text-2xl font-bold text-fg">{title}</h1>
      {subtitle ? <p className="mt-1 text-sm text-fg-muted max-w-3xl">{subtitle}</p> : null}
    </div>
    {actions ? <div className="flex flex-wrap gap-2 shrink-0">{actions}</div> : null}
  </header>
);

export default ListPageHeader;
